(function () {
  'use strict';

  /* ── Per-panel continuous slider ── */
  function initPanelSlider(panelEl) {
    var wrapper = panelEl.querySelector('.bs-products-wrapper');
    var track   = panelEl.querySelector('.bs-products');
    if (!wrapper || !track) return null;

    var outer   = panelEl.querySelector('.bs-slider-outer');
    var prevBtn = panelEl.querySelector('.bs-nav-btn--prev');
    var nextBtn = panelEl.querySelector('.bs-nav-btn--next');
    var busy    = false;
    var timer   = null;
    var cloned  = false;
    var origW   = 0;
    var rafId   = null;

    /*
      Must match the breakpoints in section-best-sellers.css:
        >= 1100px    → 6 items  (1199px still shows 6)
        992–1099px   → 4 items
        768–991px    → 3 items
        <= 767px     → 2 items
    */
    function visibleCols() {
      var w = window.innerWidth;
      if (w < 768) return 2;
      if (w < 992) return 3;
      if (w < 1100) return 4;
      return 6;
    }

    /* Duplicate the original items once so the loop is seamless */
    function buildLoop() {
      if (cloned) return;

      var items = Array.prototype.slice.call(track.children).filter(function (el) {
        return el.dataset.bsClone !== 'true';
      });
      if (!items.length) return;

      /* Nothing to loop if everything already fits */
      if (items.length <= visibleCols()) return;

      items.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.dataset.bsClone = 'true';

        /* Strip duplicate IDs so product forms / labels stay valid */
        if (c.hasAttribute('id')) c.removeAttribute('id');
        c.querySelectorAll('[id]').forEach(function (n) {
          n.removeAttribute('id');
        });

        /* Clones are decorative duplicates for the visual loop only —
           keep keyboard focus from landing on their interactive
           children (links, buttons, form fields) since they're
           aria-hidden and shouldn't be reachable by tab. */
        c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (n) {
          n.setAttribute('tabindex', '-1');
          n.setAttribute('aria-hidden', 'true');
        });

        track.appendChild(c);
      });

      cloned = true;
    }

    /* Width of the original (non-clone) half of the track */
    function measure() {
      origW = cloned ? wrapper.scrollWidth / 2 : 0;
    }

    function stepSize() {
      var first = track.children[0];
      if (!first) return 0;
      return (first.offsetWidth + 10) * visibleCols();
    }

    /* Show nav arrows only when there's actually something to scroll to.
       Prevents arrows appearing on hover but doing nothing when a tab
       has fewer products than the visible column count. */
    function updateNavVisibility() {
      if (!outer) return;
      var hasOverflow = cloned || (wrapper.scrollWidth - wrapper.clientWidth) > 1;
      outer.classList.toggle('bs-nav-hidden', !hasOverflow);
    }

    /* Invisibly wrap back once we cross into the clone half */
    function normalize() {
      if (!cloned || !origW) return;

      if (wrapper.scrollLeft >= origW) {
        wrapper.scrollLeft = wrapper.scrollLeft - origW;
      } else if (wrapper.scrollLeft < 0) {
        wrapper.scrollLeft = wrapper.scrollLeft + origW;
      }
    }

    function slide(dir) {
      if (busy) return;

      var step = stepSize();
      if (!step) return;

      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

      /* Not cloned = no overflow = nothing to scroll */
      if (!cloned && maxScroll <= 0) return;

      busy = true;

      /* Going backwards from the start: jump forward a loop, then animate back */
      if (dir < 0 && cloned && wrapper.scrollLeft < step) {
        wrapper.scrollLeft = wrapper.scrollLeft + origW;
      }

      var target = wrapper.scrollLeft + (dir * step);

      /* Never request a scroll position past the real track boundary.
         iOS Safari's elastic "rubber-band" bounce only triggers when the
         browser is asked to scroll beyond actual content — clamping here
         means it's never asked to, which stops the brief flash of blank
         space some iPhones show at the very start/end of the track. */
      target = Math.max(0, Math.min(target, maxScroll));

      wrapper.scrollTo({ left: target, behavior: 'smooth' });

      setTimeout(function () {
        normalize();
        busy = false;
      }, 550);
    }

    /* Keep the loop seamless for touch / trackpad scrolling too */
    wrapper.addEventListener('scroll', function () {
      if (busy || rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        normalize();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); });

    buildLoop();
    measure();
    updateNavVisibility();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      /* Debounced: re-check whether the track now needs to loop
         (e.g. resized from a width where products fit into one
         where they overflow), then re-measure and re-evaluate arrows. */
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildLoop();
        measure();
        updateNavVisibility();
      }, 150);
    });

    return {
      startTimer: function (autoplay, speed) {
        clearInterval(timer);
        if (autoplay) timer = setInterval(function () { slide(1); }, speed);
      },
      stopTimer: function () {
        clearInterval(timer);
        timer = null;
      },
      refresh: function () {
        buildLoop();
        measure();
        updateNavVisibility();
      }
    };
  }

  /* ── Section init ── */
  function initSection(section) {
    var autoplay = section.dataset.bsAutoplay === 'true';
    var speed    = parseInt(section.dataset.bsSpeed, 10) || 4000;

    var tabs        = section.querySelectorAll('.bs-tab');
    var panels      = section.querySelectorAll('.bs-panel');
    var viewAllLink = section.querySelector('[data-bs-view-all-link]');

    /* Init a slider for every panel */
    var sliders = {};
    panels.forEach(function (p) {
      var idx = p.dataset.bsPanel;
      if (idx !== undefined) sliders[idx] = initPanelSlider(p);
    });

    /* Start autoplay on the first active panel */
    var firstActive = section.querySelector('.bs-panel--active');
    if (firstActive && sliders[firstActive.dataset.bsPanel]) {
      sliders[firstActive.dataset.bsPanel].refresh();
      sliders[firstActive.dataset.bsPanel].startTimer(autoplay, speed);
    }

    /* Pause on hover, resume on leave */
    section.addEventListener('mouseenter', function () {
      var ap = section.querySelector('.bs-panel--active');
      if (ap && sliders[ap.dataset.bsPanel]) sliders[ap.dataset.bsPanel].stopTimer();
    });
    section.addEventListener('mouseleave', function () {
      var ap = section.querySelector('.bs-panel--active');
      if (ap && sliders[ap.dataset.bsPanel]) sliders[ap.dataset.bsPanel].startTimer(autoplay, speed);
    });

    /* Pause on keyboard focus too, so autoplay doesn't shift the
       track out from under someone tabbing through the products. */
    section.addEventListener('focusin', function () {
      var ap = section.querySelector('.bs-panel--active');
      if (ap && sliders[ap.dataset.bsPanel]) sliders[ap.dataset.bsPanel].stopTimer();
    });
    section.addEventListener('focusout', function () {
      var ap = section.querySelector('.bs-panel--active');
      if (ap && sliders[ap.dataset.bsPanel] && !section.contains(document.activeElement)) {
        sliders[ap.dataset.bsPanel].startTimer(autoplay, speed);
      }
    });

    /* ── Tab switching ── */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.dataset.bsTab;

        /* Stop outgoing panel's slider */
        var oldPanel = section.querySelector('.bs-panel--active');
        if (oldPanel && sliders[oldPanel.dataset.bsPanel]) {
          sliders[oldPanel.dataset.bsPanel].stopTimer();
        }

        tabs.forEach(function (t) {
          t.classList.remove('bs-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('bs-tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          p.classList.remove('bs-panel--active');
          p.setAttribute('aria-hidden', 'true');
        });

        var target = section.querySelector('[data-bs-panel="' + idx + '"]');
        if (target) {
          target.classList.add('bs-panel--active');
          target.setAttribute('aria-hidden', 'false');
        }

        if (viewAllLink) {
          var url = tab.dataset.bsViewAll;
          if (url) viewAllLink.href = url;
        }

        /* Panel is visible now — so it's measurable. Refresh, then start. */
        if (sliders[idx]) {
          sliders[idx].refresh();
          sliders[idx].startTimer(autoplay, speed);
        }
      });
    });

    /* ── Tab scroll arrows (mobile) ── */
    var tabsWrap   = section.querySelector('.bs-tabs-wrap');
    var tabPrevBtn = section.querySelector('.bs-tabs-arrow--prev');
    var tabNextBtn = section.querySelector('.bs-tabs-arrow--next');

    if (tabsWrap && tabPrevBtn) {
      tabPrevBtn.addEventListener('click', function () {
        var target = Math.max(0, tabsWrap.scrollLeft - 120);
        tabsWrap.scrollTo({ left: target, behavior: 'smooth' });
      });
    }
    if (tabsWrap && tabNextBtn) {
      tabNextBtn.addEventListener('click', function () {
        var maxScroll = tabsWrap.scrollWidth - tabsWrap.clientWidth;
        var target = Math.min(maxScroll, tabsWrap.scrollLeft + 120);
        tabsWrap.scrollTo({ left: target, behavior: 'smooth' });
      });
    }
  }

  document.querySelectorAll('[data-bs-section]').forEach(initSection);
})();
